// The home page can render two layouts side by side while the team decides
// which one ships (a third, map-first, was tried and dropped on 2026-08-29). Everything here is pure so the choice logic is testable.
import { distanceKm } from './nearby'

export const LAYOUTS = ['current', 'panel']

/**
 * With the switcher shown: ?layout= wins, then what the visitor last used,
 * then the configured default. With it hidden the configured default is the
 * only answer -- a stale stored choice must not resurrect a retired layout.
 * An unknown default falls back to 'current'.
 */
export function resolveLayout(queryValue, stored, { defaultLayout = 'current', allowOverride = true } = {}) {
  const fallback = LAYOUTS.includes(defaultLayout) ? defaultLayout : 'current'
  if (!allowOverride) return fallback
  if (LAYOUTS.includes(queryValue)) return queryValue
  if (LAYOUTS.includes(stored)) return stored
  return fallback
}

const coord = v => {
  const n = typeof v === 'number' ? v : parseFloat(v)
  return Number.isFinite(n) ? n : null
}

/** Bounds are {south, west, north, east}; null bounds means "not measured yet". */
export function withinBounds(item, bounds) {
  if (!bounds) return true
  const lat = coord(item && item.lat), lng = coord(item && item.lng)
  if (lat === null || lng === null) return false
  return lat >= bounds.south && lat <= bounds.north && lng >= bounds.west && lng <= bounds.east
}

export function boundsCenter(bounds) {
  return { lat: (bounds.south + bounds.north) / 2, lng: (bounds.west + bounds.east) / 2 }
}

export function sortByDistanceTo(items, point) {
  return items
    .map(item => ({ item, km: distanceKm(item, point) }))
    .sort((a, b) => a.km - b.km)
    .map(x => x.item)
}
